export default "__VITE_ASSET__IngeT6dE__"